<template>
    <!--collapse 是否水平折叠收起菜单-->
    <el-scrollbar style="height:100%;width: 100%;">
        <el-menu
                :collapse="isCollapse"
                unique-opened
                :default-active="$route.path"
                class="el-menu-demo"
                background-color="#545c64"
                text-color="#fff"
                active-text-color="#ffd04b"
                mode="vertical"
                :default-openeds=[1]
        >
            <!--是否水平折叠收起菜单 会影响这里字段的显示 -->
            <h3 v-show="isCollapse" class="logos"><img src="../assets/img/logo/z_logo.png" class="logimg"/></h3>
            <h3 v-show="!isCollapse" class="logo">
                <img src="../assets/img/logo/z_logo.png" class="logimg"/>
            </h3>

            <el-menu-item :index="item.path" v-for="item in noChildren" :key="item.path" @click="clickMenu(item)"
                          class="tp1">
                <i :class="'el-icon-' + item.icon"></i>
                <span slot="title">{{ item.label }}</span>
            </el-menu-item>
            <el-submenu :index="1" v-for="(item, index) in hasChildren" :key="index">
                <template slot="title">
                    <i :class="'el-icon-' + item.icon"></i>
                    <span slot="title">{{ item.label }}</span>
                </template>
                <fragment v-for="(subitem, subIndex) in item.children" :key="subIndex">
                    <el-submenu :index="subitem.label" v-if="subitem.chb">
                        <template slot="title">
                            <i :class="'el-icon-' + subitem.icon"></i>
                            <span slot="title">{{ subitem.label }}</span>
                        </template>
                        <fragment v-for="(subitems, subIndexs) in subitem.children" :key="subIndexs">
                            <el-submenu v-if="subitems.chb" :index="subitems.label">
                                <template slot="title">
                                    <i :class="'el-icon-' + subitems.icon"></i>
                                    <span slot="title">{{ subitems.label }}</span>
                                </template>
                                <el-menu-item v-for="(subitemss, subIndexss) in subitems.children" :key="subIndexss"
                                              :index="subitemss.path" @click="clickMenu(subitemss)">
                                    <i :class="'el-icon-' + subitemss.icon"></i>
                                    <span slot="title">{{ subitemss.label }}</span>
                                </el-menu-item>
                            </el-submenu>
                            <el-menu-item v-else :index="subitems.path" @click="clickMenu(subitems)">
                                <i :class="'el-icon-' + subitems.icon"></i>
                                <span slot="title">{{ subitems.label }}</span>
                            </el-menu-item>
                        </fragment>
                    </el-submenu>
                    <el-menu-item :index="subitem.path" @click="clickMenu(subitem)" v-else>
                        <i :class="'el-icon-' + subitem.icon"></i>
                        <span slot="title">{{ subitem.label }}</span>
                    </el-menu-item>
                </fragment>
            </el-submenu>
        </el-menu>
    </el-scrollbar>
</template>

<script>
    export default {
        //计算属性
        computed: {
            //没有子菜单
            noChildren() {
                return this.menu.filter(item => !item.children);
            },
            //有子菜单 (这样设置会有一个问题 就是有子菜单的 永远会在没有子菜单的下面
            hasChildren() {
                // console.log(this.menu);
                return this.menu.filter(item => item.children);
            },
            isCollapse() {
                // 这里的数据就是从vuex取得
                return this.$store.state.tab.isCollapse;
            }
        },
        data() {
            return {
                menu: [],
            };
        },
        created() {
            this.setOptions();
        },
        methods: {
            setOptions() {
                this.menu = [
                    {
                        path: '/',
                        name: 'dhome',
                        label: '主页',
                        icon: 's-home',
                        chb: false,
                        url: 'dealer/dhome'
                    },
                    {
                        label: '功能面板',
                        icon: 'video-play',
                        chb: true,
                        children: [
                            {
                                path: '/dpersonalcenter',
                                name: 'dpersonalcenter',
                                label: '个人中心',
                                icon: 'arrow-right',
                                chb: false,
                                url: 'dealer/dpersonalcenter'
                            },
                            {
                                path: '/dproductsshow',
                                name: 'dproductsshow',
                                label: '产品展示',
                                icon: 'arrow-right',
                                chb: false,
                                url: 'dealer/dproductsshow'
                            },
                            {
                                path: '/dordermanage',
                                name: 'dordermanage',
                                label: '下单管理',
                                icon: 'arrow-right',
                                chb: false,
                                url: 'dealer/dordermanage'
                            },
                            {
                                path: '/dsalesinformation',
                                name: 'dsalesinformation',
                                label: '销售信息记录',
                                icon: 'arrow-right',
                                chb: false,
                                url: 'dealer/dsalesinformation'
                            },
                            {
                                path: '/dpointsdetails',
                                name: 'dpointsdetails',
                                label: '积分明细',
                                icon: 'arrow-right',
                                chb: false,
                                url: 'dealer/dpointsdetails'
                            },
                        ]
                    },
                ]
            },
            //跳转路由 根据名称跳转
            clickMenu(item) {
                //console.log(item);
                this.$store.commit('selectMenu', item);
                this.$router.push(item);
            },
            handleOpen(index,indexPath){
                console.log(index,indexPath)
            }
        }
    };
</script>

<style lang="scss" scoped>
    .el-menu {
        height: 100%;
        border: none;
        .logos {
            width: 65px;
        }
        .logo {
            width: 240px;
            font-size: medium;
        }
        h3 {
            display: flex;
            height: 60px;
            line-height: 60px;
            background: #333333;
            color: #fff;
            text-align: center;
            position: fixed;
            z-index: 1;
            cursor: pointer;
            .logimg {
                width: 40px;
                height: 40px;
                display: inline-block;
                margin: 5px 8px;
            }
        }
    }

    // .el-menu-item.is-active {
    //    background-color: rgb(231, 235, 240) !important;
    // }
    // li.el-menu-item {
    // 	background: #000000 !important;
    // }
    // .el-submenu__title {
    // 	background: #00ff7f !important;
    // }
    // .el-submenu>.el-submenu__title {
    //     background: #000000 !important;
    // }
    ul > li.el-submenu__title {
        background: #55ff00 !important;
    }

    ul > li > ul > li.el-submenu__title {
        background: #4a4747 !important;
    }

    .el-menu-demo:not(.el-menu--collapse) {
        width: 240px;
        min-height: 400px;
    }

    .horizontal-collapse-transition {
        transition: 0s width ease-in-out, 0s padding-left ease-in-out, 0s padding-right ease-in-out;
    }
</style>
